import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "COTAD | Circle of the Awesomely Diverse",
  description = "An inclusive community providing support and sanctuary for youth aged 11-30.",
  pathname = "",
  children = null
}) => {
  const siteUrl = "https://dragoncoven.org";
  const canonical = pathname ? `${siteUrl}${pathname}` : siteUrl;

  const defaultMeta = [
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    { charSet: "utf-8" },
    { name: "theme-color", content: "#0F172A" },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    { property: "og:url", content: canonical },
    { property: "og:site_name", content: "COTAD" },
  ];

  return (
    <Helmet 
      title={title}
      link={[
        { rel: "canonical", href: canonical }
      ]}
      meta={defaultMeta}
    >
      {children}
    </Helmet>
  );
};

export default SEO;
